import React from 'react';
import Layout from '~/components/layout/_layout';
import SEO from '~/components/seo';
import { Trans, withI18n } from '@lingui/react';
import LeadForm from '~/components/leadForm';
import getConfig from 'next/config';
import { t } from '@lingui/macro';
import {useRouter} from "next/router";
import {getPricingQueryParams} from "../../src/services/business/pricing/get-signup-link";

const { publicRuntimeConfig } = getConfig();

function JoinUs() {
    const router = useRouter();
    const tierParams = getPricingQueryParams(router);
    return (
        <Layout welcome={false}>
            <SEO
                title={t`page.joinUs.seo.title`}
                description={t`page.joinUs.seo.description`}
            />
            <LeadForm
                tierParams={tierParams}
                googleScript={publicRuntimeConfig.FORM.onboarding.IT}
            />
        </Layout>
    );
};

export default withI18n()(JoinUs);
